import script from "./Vnc.vue?vue&type=script&setup=true&lang=js"
export * from "./Vnc.vue?vue&type=script&setup=true&lang=js"

import "./Vnc.vue?vue&type=style&index=0&id=0355b004&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/qixiao_410_6413_沙箱云前端生产环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0355b004"]])

export default __exports__